const error = {
    view_error: 'Erreur lors du chargement de la vue.'
}

export default error
